import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import blogo from "../../assets/images/bilcono.jpg";
import { handleAPIRequest } from "../../api/api"; // Assuming API function
import { useSelector } from "react-redux";

const Footer = () => {
  const [data, setData] = useState({
    countries: [],
    email1: "",
    email2: "",
    contact1: "",
    contact2: "",
    address1: "",
    address2: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch countries
        const response = await handleAPIRequest("get", "get-country-names", null,null);
      

        setData((prevState) => ({
          ...prevState,
          countries: response.countries || [],
          email1: response.email1 || "",
          email2: response.email2 || "",
          contact1: response.contact1 || "",
          contact2: response.contact2 || "",
          address1: response.address1 || "",
          address2: response.address2 || "",
        }));
      } catch (error) {
        console.error("Failed to fetch footer details:", error);
        setData((prevState) => ({
          ...prevState,
          countries: [],
          email1: "",
          email2: "",
          contact1: "",
          contact2: "",
          address1: "",
          address2: "",
        }));
      }
    };

    fetchData();
  }, []);

  return (
    <footer className="bg-gradient-to-br from-blue-200 to-green-300 p-6 text-gray-900 shadow-lg backdrop-blur-md">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        
        {/* Navbar Links */}
        <div className="mb-4 md:mb-0">
          <ul className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
            <li>
              <Link to="/" className="hover:text-blue-700 transition-all duration-300">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about-us" className="hover:text-blue-700 transition-all duration-300">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="hover:text-blue-700 transition-all duration-300">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/tenders/national" className="hover:text-blue-700 transition-all duration-300">
                National Tenders
              </Link>
            </li>
            <li>
              <Link to="/tenders/international" className="hover:text-blue-700 transition-all duration-300">
                International Tenders
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Information */}
        <div className="flex flex-col md:flex-row items-center md:space-x-6 text-sm text-gray-800">
          <p>
            For Sales: <strong className="text-blue-700">{data.email1 || "N/A"}</strong>
          </p>
          <p>
            For Support: <strong className="text-blue-700">{data.email2 || "N/A"}</strong>
          </p>
          <p>
            24/7 Support: <strong className="text-blue-700">{data.contact1 || "N/A"}</strong>
          </p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-6 border-t border-gray-400 pt-4 text-center">
        {/* Logo - Optional */}
        {/* <img
          src={blogo}
          alt="Bilcono Logo"
          className="w-24 h-auto mx-auto mb-3 shadow-md rounded-full"
        /> */}
        <p className="text-gray-900 font-semibold">&copy; 2024 Bilcono. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
